import { Directive } from '@angular/core';
import { BrziObrazacAttributeStateService } from '@app/services/brzi-obrazac-attribute-state.service';
import { AttributeStateService } from '@ntap/core';

@Directive({
  selector: '[appBrziObrazacStateServiceProvider]',
  providers: [
    BrziObrazacAttributeStateService,
    {
      provide: AttributeStateService,
      useExisting: BrziObrazacAttributeStateService
    }
  ]
})
export class BrziObrazacStateServiceProviderDirective {}
